module.exports = __webpack_public_path__ + "bf37414249230f855584b778dbd4f336.svg";